import Vue from 'vue';

import { RouterVue } from './router';
import { LanguageVue } from './language';
import ul from './ul';
import api from './api';
import FormPlugin from './form';

Vue.prototype.$api = api;
export default {
  install(vue, options) {
    vue.use(RouterVue, options);
    vue.use(ul, options);
    vue.use(LanguageVue, options);
    vue.use(FormPlugin, options);
  },
};
